module.exports = __webpack_public_path__ + "static/media/imagen5.46cd4f33.jpg";